function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-gear_svg__a",
  d: "M8.051 3.512a.75.75 0 01-.451.46 6.81 6.81 0 00-1.793.98.75.75 0 01-.596.14L3.26 4.715 1.922 7.034l1.236 1.428a.75.75 0 01.175.603 6.236 6.236 0 000 1.87.75.75 0 01-.175.603l-1.236 1.428 1.338 2.318 1.95-.375a.75.75 0 01.597.14 6.81 6.81 0 001.793.98.75.75 0 01.451.459l.61 1.762h2.677l.611-1.762a.75.75 0 01.451-.46 6.81 6.81 0 001.793-.98.75.75 0 01.596-.14l1.951.376 1.338-2.318-1.236-1.428a.75.75 0 01-.175-.603 6.236 6.236 0 000-1.87.75.75 0 01.175-.603l1.236-1.428-1.338-2.318-1.95.375a.75.75 0 01-.597-.14 6.81 6.81 0 00-1.793-.98.75.75 0 01-.451-.459l-.61-1.762H8.661L8.05 3.512zM7.42.754A.75.75 0 018.128.25h3.744a.75.75 0 01.708.504l.673 1.94a8.31 8.31 0 011.573.863l2.155-.415a.75.75 0 01.791.362l1.872 3.242a.75.75 0 01-.082.866L18.195 9.19a7.758 7.758 0 010 1.62l1.367 1.578a.75.75 0 01.082.866l-1.872 3.242a.75.75 0 01-.79.362l-2.156-.415a8.31 8.31 0 01-1.573.863l-.673 1.94a.75.75 0 01-.708.504H8.128a.75.75 0 01-.708-.504l-.673-1.94a8.31 8.31 0 01-1.573-.863l-2.155.415a.75.75 0 01-.791-.362L.356 13.254a.75.75 0 01.082-.866l1.367-1.578a7.758 7.758 0 010-1.62L.438 7.612a.75.75 0 01-.082-.866l1.872-3.242a.75.75 0 01.79-.362l2.156.415a8.31 8.31 0 011.573-.863L7.42.754zM10 13.563a3.563 3.563 0 100-7.126 3.563 3.563 0 000 7.125zm0-1.5a2.062 2.062 0 110-4.125 2.062 2.062 0 010 4.125z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-2-2h24v24H-2z"
}), React.createElement("mask", {
  id: "icon-gear_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#icon-gear_svg__a"
})), React.createElement("g", {
  fill: "#000",
  mask: "url(#icon-gear_svg__b)"
}, React.createElement("path", {
  d: "M-2-2h23.731v23.731H-2z"
})));

var SvgIconGear = function SvgIconGear(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-gear.103967c2.svg";
export { SvgIconGear as ReactComponent };